import { AppLayout } from 'layouts';
import { useNavigate } from 'react-router';
import { Calendar } from 'features/calendar';
import { useFeedbackOptions, useGetPathToEntityDetail } from '../../hooks';
import { useCalendarSearchParams, useCreateReminderParams } from '../hooks';

const PageCalendar = () => {
  const getPathToEntityDetail = useGetPathToEntityDetail();
  const navigate = useNavigate();
  const searchParamsOptions = useCalendarSearchParams();
  const createReminderParams = useCreateReminderParams();
  const feedbackOptions = useFeedbackOptions();

  return (
    <AppLayout fitCenterContent stretchCenter>
      <Calendar
        createReminderParams={createReminderParams}
        feedbackOptions={feedbackOptions}
        getPathToEventDetail={(id) => getPathToEntityDetail(id, { entityType: 'event' })}
        navigateToEventDetail={async (id) => {
          await navigate(getPathToEntityDetail(id, { entityType: 'event' }));
        }}
        searchParamsOptions={searchParamsOptions}
      />
    </AppLayout>
  );
};

export default PageCalendar;
